/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {ConfirmModalComponent} from './confirm-modal.component';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ExistingFileModalComponent} from './existing-file-modal/existing-file-modal.component';

/**
 * @deprecated
 */
@NgModule({
    declarations: [
        ConfirmModalComponent,
        ExistingFileModalComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ConfirmModalComponent,
        ExistingFileModalComponent
    ],
    providers: [
        NgbActiveModal
    ]
})
export class ConfirmModalModule {
}
